<template>
<nav :aria-label="$t('sidebar-navigation')" role="navigation">
	<ul class="nav nav-pills flex-column flex-md-row" role="tablist" :aria-label="$t('sidebar-navigation')">
		<!-- all of this complicated router-link code is to get active on both li and a -->
		<router-link to="/" v-slot="{ href, navigate, isExactActive }" custom>
			<li class="nav-item" :class="{'active': isExactActive }">
				<a class="nav-link" role="tab" :class="{'active': isExactActive }" :href="href" @click="navigate">{{ $t('upcoming-notices') }}</a>
			</li>
		</router-link>
		<router-link to="/notices" v-slot="{ href, navigate, isActive }" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('notices') }}</a>
			</li>
		</router-link>
		<router-link to="/subscribe" v-slot="{ href, navigate, isActive}" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('subscribe') }}</a>
			</li>
		</router-link>
		<router-link to="/map" v-slot="{ href, navigate, isActive }" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('map') }}</a>
			</li>
		</router-link>
		<router-link v-if="is_detail" :to="{name: 'Detail', params: { id: route_id }}" v-slot="{ href, navigate, isActive }" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('notice-detail') }}</a>
			</li>
		</router-link>
		<router-link v-if="is_unsubscribe" :to="{name: 'Unsubscribe', params: { id: route_id, token: route_token }}" v-slot="{ href, navigate, isActive }" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('unsubscribe') }}</a>
			</li>
		</router-link>
		<router-link to="/definitions" v-slot="{ href, navigate, isActive }" custom>
			<li class="nav-item" :class="{'active': isActive}">
				<a class="nav-link" role="tab" :class="{'active': isActive}" :href="href" @click="navigate">{{ $t('definitions') }}</a>
			</li>
		</router-link>
	</ul>
</nav>
</template>

<script>
	export default {

		computed: {
			is_unsubscribe() {
				return (this.$route.name === 'Unsubscribe');
			},
			is_detail() {
				return (this.$route.name === 'Detail');
			},
			route_id() {
				if (this.$route.params.id) {
					return this.$route.params.id;
				} else {
					return '0';
				}
			},
			route_token() {
				if (this.$route.params.token) {
					return this.$route.params.token;
				}
				return '0';
			}
		}

	}
</script>

<style >

</style>
